import React from 'react';
import { stats } from '../data/hero';
export function Stats() {
  return <section aria-label="Estadísticas de confianza" className="border-y border-azul/10 bg-ink-2" data-id="element-154" data-mp="2wxq9bxqydsbk">
      <div className="mx-auto max-w-5xl px-5 py-8" data-id="element-155" data-mp="2ixxouk60s8c1">
        <dl className="grid grid-cols-2 gap-6 sm:grid-cols-4" data-id="element-156" data-mp="2ixfkf097ent1">
          {stats.map(s => <div key={s.label} className="text-center" data-id="element-157" data-mp="2nvqrj3846k7k">
              <dt className="font-display text-4xl font-bold text-white sm:text-5xl" data-id="element-158" data-mp="298e418yqy4ej">{s.value}</dt>
              <dd className="mt-1 text-sm font-medium text-white/60" data-id="element-159" data-mp="2dym6j6q08usc">{s.label}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}